"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var uuid_1 = require("uuid");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var Overlay_1 = require("../Overlay");
var useMediaQuery_1 = require("../responsive/useMediaQuery");
var SCROLLBAR_SELECTOR = ".fixedDataTableLayout_main .ScrollbarLayout_main";
var MOBILE_DROPDOWN_ALIGN_POINTS = [
    {
        align: "tl tl",
    },
];
/**
 * Element.matches is only supported via prefix in IE11 and Edge.
 */
function matches(element, selector) {
    var _a;
    var matchesImpl = (_a = element.matches) !== null && _a !== void 0 ? _a : element.msMatchesSelector;
    return matchesImpl.call(element, selector);
}
/**
 * Prevent the overlay from closing when scrolling and finishing
 * with a cursor position outside of the overlay.
 */
function shouldCloseOnClick(e) {
    var _a;
    var activeElement = (_a = document.activeElement) !== null && _a !== void 0 ? _a : e.target;
    if (!activeElement) {
        return false;
    }
    var hasScrolled = matches(activeElement, SCROLLBAR_SELECTOR);
    return !hasScrolled;
}
/**
 * @internal
 */
exports.Dropdown = function (props) {
    var className = props.className, openOnInit = props.openOnInit, closeOnParentScroll = props.closeOnParentScroll, closeOnMouseDrag = props.closeOnMouseDrag, _a = props.closeOnOutsideClick, closeOnOutsideClick = _a === void 0 ? true : _a, overlayPositionType = props.overlayPositionType, _b = props.alignPoints, alignPoints = _b === void 0 ? [
        {
            align: "bl tl",
        },
    ] : _b, overlayZIndex = props.overlayZIndex, _c = props.ignoreClicksOnByClass, ignoreClicksOnByClass = _c === void 0 ? [] : _c, renderBody = props.renderBody, renderButton = props.renderButton, onOpenStateChanged = props.onOpenStateChanged, _d = props.fullscreenOnMobile, fullscreenOnMobile = _d === void 0 ? true : _d, _e = props.enableEventPropagation, enableEventPropagation = _e === void 0 ? false : _e;
    var _f = tslib_1.__read(react_1.useState({
        isOpen: !!openOnInit,
        dropdownId: "dropdown-" + uuid_1.v4(),
    }), 2), _g = _f[0], isOpen = _g.isOpen, dropdownId = _g.dropdownId, setState = _f[1];
    var _renderButton = function (renderProps) { return (react_1.default.createElement("div", { className: dropdownId }, renderButton(renderProps))); };
    var toggleDropdown = react_1.useCallback(function () {
        setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { isOpen: !state.isOpen })); });
    }, []);
    var closeDropdown = react_1.useCallback(function () {
        setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { isOpen: false })); });
    }, []);
    var openDropdown = react_1.useCallback(function () {
        setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { isOpen: true })); });
    }, []);
    var mountRef = react_1.useRef(false);
    react_1.useEffect(function () {
        if (mountRef.current && onOpenStateChanged) {
            onOpenStateChanged(isOpen);
        }
        return function () {
            mountRef.current = true;
        };
    }, [isOpen]);
    var renderButtonProps = {
        isOpen: isOpen,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown,
    };
    var isMobileDevice = useMediaQuery_1.useMediaQuery("mobileDevice");
    var renderDropdown = isOpen &&
        (fullscreenOnMobile && isMobileDevice ? (react_1.default.createElement(Overlay_1.FullScreenOverlay, { alignTo: "body", alignPoints: MOBILE_DROPDOWN_ALIGN_POINTS },
            react_1.default.createElement("div", { className: "gd-mobile-dropdown-overlay overlay gd-flex-row-container" },
                react_1.default.createElement("div", { className: "gd-mobile-dropdown-header gd-flex-item" }, _renderButton(tslib_1.__assign(tslib_1.__assign({}, renderButtonProps), { isMobile: true }))),
                react_1.default.createElement("div", { className: "gd-mobile-dropdown-content gd-flex-item-stretch gd-flex-row-container" }, renderBody({
                    closeDropdown: closeDropdown,
                    isMobile: true,
                }))))) : (react_1.default.createElement(Overlay_1.Overlay, { alignTo: "." + dropdownId, positionType: overlayPositionType, alignPoints: alignPoints, closeOnOutsideClick: closeOnOutsideClick, closeOnMouseDrag: closeOnMouseDrag, closeOnParentScroll: closeOnParentScroll, shouldCloseOnClick: shouldCloseOnClick, ignoreClicksOnByClass: ignoreClicksOnByClass, onClose: closeDropdown, 
            // Overlay prevents event propagation by default using defaultProps for these
            onClick: enableEventPropagation ? noop_1.default : undefined, onMouseOver: enableEventPropagation ? noop_1.default : undefined, onMouseUp: enableEventPropagation ? noop_1.default : undefined, zIndex: overlayZIndex },
            react_1.default.createElement("div", { className: "overlay dropdown-body" }, renderBody({
                closeDropdown: closeDropdown,
                isMobile: false,
            })))));
    return (react_1.default.createElement("div", { className: className },
        _renderButton(tslib_1.__assign(tslib_1.__assign({}, renderButtonProps), { isMobile: false })),
        renderDropdown));
};
//# sourceMappingURL=Dropdown.js.map